export default theme => ({

  clear: {
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
    top: theme.spacing.unit * 0.75,
    left: theme.spacing.unit * 0.5
  },

  button: {
    'white-space': 'nowrap'
  },

  buttonIcon: {
    marginRight: theme.spacing.unit
  }

});




// WEBPACK FOOTER //
// ./src/shared/styles/components/Datepicker.js